var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 33,
    viewBox: "0 0 187 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1926_19361)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1926_19361",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.483 0.306213H0V31.7379H186.483V0.306213Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1926_19361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.382 0.306274H127.288V31.738H126.382V0.306274Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0361 0.337463L51.3494 2.25682V6.61126L66.0361 5.30179V0.337463Z",
    fill: "#E40038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1646 16.1946C21.1646 18.8361 21.9493 19.7553 24.4741 19.7553C26.9988 19.7553 27.7747 18.8361 27.7747 16.1946C27.7747 13.5533 27.0123 12.634 24.4741 12.634C21.9359 12.634 21.1646 13.5398 21.1646 16.1946ZM16.7294 16.1544C16.7294 11.3111 19.4156 9.10022 24.4786 9.10022C29.5416 9.10022 32.2412 11.3155 32.2412 16.1544C32.2412 20.9931 29.5684 23.2891 24.4786 23.2891C19.3887 23.2891 16.7294 20.9976 16.7294 16.1544Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2521 10.3155L51.3458 2.2569V6.60684L55.0589 9.12264L55.7899 9.54866C54.4624 9.5666 53.8167 9.83567 53.1754 10.2213C51.3412 11.329 50.3905 13.2753 50.3905 16.1543C50.3905 20.9976 53.0633 23.2891 58.1397 23.2891C63.2162 23.2891 65.9023 20.9976 65.9023 16.1543C65.9023 13.3516 64.992 11.4366 63.2521 10.3155ZM58.1397 19.7553C55.615 19.7553 54.8302 18.836 54.8302 16.1947C54.8302 13.5533 55.615 12.634 58.1397 12.634C60.6645 12.634 61.4403 13.5398 61.4403 16.1947C61.4403 18.8495 60.6779 19.7553 58.1397 19.7553Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08556 9.07324C6.69085 9.07324 4.7401 10.5531 4.25578 11.1675V9.38716H0V27.5897H4.22887V21.1186C4.72664 21.7464 6.65945 23.1994 9.07211 23.1994C13.0767 23.1994 15.2787 21.0244 15.2787 16.1318C15.2787 11.2392 13.0767 9.07772 9.08556 9.07772V9.07324ZM7.56981 19.6701C5.04504 19.6701 4.26026 18.7507 4.26026 16.1094C4.26026 13.4681 5.04504 12.5487 7.56981 12.5487C10.0946 12.5487 10.8704 13.4546 10.8704 16.1094C10.8704 18.7642 10.108 19.6701 7.56981 19.6701Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9948 9.40521V14.3426H89.3846V9.40521H85.1288V22.7689H89.3846V17.7643H94.9948V22.7689H99.2504V9.40521H94.9948Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.369 16.1318C67.369 21.0244 69.5709 23.1994 73.5755 23.1994C75.9837 23.1994 77.921 21.7464 78.4188 21.1186V22.7733H82.6476V9.38716H78.3918V11.1675C77.9075 10.5531 75.9613 9.07324 73.562 9.07324C69.5709 9.07324 67.369 11.2483 67.369 16.1274V16.1318ZM71.7772 16.1139C71.7772 13.459 72.5396 12.5532 75.0778 12.5532C77.616 12.5532 78.3874 13.459 78.3874 16.1139C78.3874 18.7552 77.6026 19.6745 75.0778 19.6745C72.5396 19.6745 71.7772 18.7552 71.7772 16.1139Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5803 17.8315C44.2529 19.2307 43.3515 19.7553 41.4322 19.7553C38.9074 19.7553 38.1226 18.8361 38.1226 16.1946C38.1226 13.5533 38.9074 12.634 41.4322 12.634C43.3515 12.634 44.2529 13.1542 44.5803 14.5579L49.0199 14.2216C48.3562 10.7236 45.7642 9.10022 41.4322 9.10022C36.3692 9.10022 33.683 11.3155 33.683 16.1544C33.683 20.9931 36.3558 23.2891 41.4322 23.2891C45.7552 23.2891 48.3248 21.6299 49.0065 18.1678L44.5803 17.8315Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.259 22.7689L110.524 15.7508L116.896 9.40521H111.636L105.923 15.2081V9.40521H101.743V22.7689H105.923V18.0962V16.9391V16.6162L111.788 22.7689H117.259Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.839 9.34247L139.171 15.3203C138.87 18.0783 138.422 19.8451 137.803 20.7061H136.175V26.7289H138.211V22.7466H150.131V26.7289H152.167V20.7061H149.785V9.34247H139.834H139.839ZM147.593 11.3785V20.7017H140.05C140.538 19.7061 140.884 18.1365 141.207 15.5041L141.664 11.3739H147.593V11.3785Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.476 22.7421V9.34247H183.79L178.409 19.9169L173.005 9.34247H170.238V22.7421H172.332V12.4861L177.611 22.8229H179.05L184.329 12.4592V22.7421H186.476Z",
    fill: "#00274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.205 9.05988C155.775 9.05988 153.433 11.4636 153.433 16.0108C153.433 20.5581 155.775 23.0245 160.205 23.0245C164.637 23.0245 166.977 20.5985 166.977 16.0108C166.977 11.4232 164.637 9.05988 160.205 9.05988ZM164.676 16.0377C164.676 19.6791 163.506 20.9707 160.205 20.9707C156.905 20.9707 155.748 19.6791 155.748 16.0377C155.748 12.3963 156.954 11.1048 160.205 11.1048C163.457 11.1048 164.676 12.4411 164.676 16.0377Z",
    fill: "#00274F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1926_19361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186.483,
    height: 32,
    fill: "white",
    transform: "translate(0 0.213196)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbLogo);
export default __webpack_public_path__ + "static/media/rb-logo.3de1875910221745fa06ce1e3a7d6b0c.svg";
export { ForwardRef as ReactComponent };